import React, { useState } from "react";
import MyCollection from "./MyCollection";
import Profile from "./Profile";
import "./Dashboard.css";
import UploadForm from "./Image-uploader/UploadForm";
import ImageGrid from "./Image-uploader/ImageGrid";
import ImageModal from "./Image-uploader/ImageModal";
import Navbar from "../Navbar";
import Footer from "../Footer";

function Dashboard() {
  const [selectedImg, setSelectedImg] = useState(null);

  return (
    <div>
      <Navbar />
      <div className="dashboard">
        <div class="sidebar">
          <h1>My Account</h1>
          <a href="/">Home</a>
          <a href="#profilescrollspy">Profile</a>
          <a href="#mycollscrollspy">My Collection</a>
          <a href="/Collection">Collection</a>
          <a href="/Blog">Blog</a>
        </div>

        <div className="right-interface">
          <div id="profilescrollspy">
            <Profile />
          </div>
          <div id="mycollscrollspy">
            <UploadForm />
            {selectedImg && (
              <ImageModal
                selectedImg={selectedImg}
                setSelectedImg={setSelectedImg}
              />
            )}
            <ImageGrid setSelectedImg={setSelectedImg} />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Dashboard;
